import React from 'react';
import styles from './style.module.scss';

interface HeaderProgressBarProps {
  currentValue: number;
  maxValue: number;
}

const HeaderProgressBar: React.FC<HeaderProgressBarProps> = ({ currentValue, maxValue }) => {

  const fillWidth = (currentValue / maxValue) * 100;

  return (
    <div className={styles['progress-bar-container']}>
      <div
        className={styles['progress-bar-fill']}
        style={{ width: `${fillWidth.toFixed(0)}%` }}
      ></div>
    </div>
  );

};

export default HeaderProgressBar;
